module.exports = __webpack_public_path__ + "img/about_con_1-4.35e6b4d9.png";